<div class="fill-blanks-widget">
  <lib-question-hint
    class="animate__animated"
    [hint]="(type === types.DRAG_AND_DROP ? 'SLIDES_drag_missing_words_into_text' : 'SLIDES.type_in_the_missing_words_to_complete_text') | translate">
  </lib-question-hint>

  <div cdkDropListGroup>
    <div
      class="fill-blanks animate__animated"
      [class.drag-and-drop-type]="type === types.DRAG_AND_DROP"
      [ngClass]="animation"
      [style.animationDelay.ms]="animationDelay">
      @for (node of nodeList; track node) {
        @switch (node.nodeName) {
          @case ('P') {
            <div class="fill-blanks-nodes">
              <ng-container *ngTemplateOutlet="itemsTmp; context: { itemList: node.items }"></ng-container>
            </div>
          }
          @case ('UL') {
            <ul>
              @for (row of node.rows; track row) {
                <li>
                  <div class="fill-blanks-nodes">
                    <ng-container *ngTemplateOutlet="itemsTmp; context: { itemList: row.items }"></ng-container>
                  </div>
                </li>
              }
            </ul>
          }
          @case ('OL') {
            <ol>
              @for (row of node.rows; track row) {
                <li>
                  <div class="fill-blanks-nodes">
                    <ng-container *ngTemplateOutlet="itemsTmp; context: { itemList: row.items }"></ng-container>
                  </div>
                </li>
              }
            </ol>
          }
        }
      }

      <ng-template #itemsTmp let-itemList="itemList">
        <div class="blank-list-item"></div>
        @for (item of itemList; track item; let i = $index) {
          <ng-container *ngTemplateOutlet="item.isInput ? inputTmp : textTmp; context: { item: item }"></ng-container>
        }
      </ng-template>

      <ng-template #textTmp let-item="item">
        <span class="ck-text" [class.d-block]="item == '\n'" [innerHtml]="item | safeHtml"></span>
      </ng-template>

      <ng-template #inputTmp let-item="item">
        @switch (type) {
          @case (types.TYPE_IN) {
            <div class="input-group" [formGroup]="$any(formArray)">
              <ng-container [formGroupName]="item.index">
                <input class="input" formControlName="text">
              </ng-container>
            </div>
          }
          @case (types.DRAG_AND_DROP) {
            <div
              class="fill-blank-drop-container"
              cdkDropList
              [cdkDropListData]="{ index: item.index }"
              (cdkDropListDropped)="drop($event)"
              (click)="dropActiveOptionToContainer(item.index)">
              @if (formArray.at(item.index)?.value; as option) {
                @if (option?.id) {
                  <div
                    class="fill-blank-option"
                    [class.active-option]="option.id === activeOption?.id"
                    cdkDrag
                    [cdkDragData]="option"
                    (cdkDragStarted)="setActiveOption(null)"
                    cdkDragPreviewClass="fill-blank-option-preview">
                    <span class="fill-blank-option-text" [innerHTML]="option.text | safeHtml"></span>
                  </div>
                }
              }
            </div>
          }
        }
      </ng-template>

    </div>


    @if (type === types.DRAG_AND_DROP) {
      <div
        class="fill-blanks-options-container"
        cdkDropList
        cdkDropListSortingDisabled
        [cdkDropListData]="{ index: -1 }"
        (cdkDropListDropped)="drop($event)">
        @if (options.length === 0) {
          <div class="options-empty">
            <lib-icon icon="check-circle" class="options-empty-icon"></lib-icon>
          </div>
        }
        @for (item of options; track item) {
          <div
            class="fill-blank-option"
            [class.active-option]="item.id === activeOption?.id"
            cdkDrag
            [cdkDragData]="item"
            cdkDragPreviewClass="fill-blank-option-preview"
            (cdkDragStarted)="setActiveOption(null)"
            (click)="setActiveOption(item)">
            <span class="fill-blank-option-text" [innerHTML]="item.text | safeHtml"></span>
          </div>
        }
      </div>
    }

  </div>

</div>
